import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-346bdb58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entity" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-line" }, "Posts", -1))
const _hoisted_3 = { class: "title-link" }
const _hoisted_4 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_table, {
      class: "the-table",
      data: _ctx.posts,
      "show-header": false,
      size: "small"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "Date",
          label: "日期",
          width: "100px",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "Title",
          label: "标题"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_router_link, {
              to: { name: 'Post', params: { path: scope.row.Path } }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, { type: "text" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(scope.row.Title), 1)
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}